import { useEffect, useState } from 'react'

/**
 * Width at or below which the app switches to its mobile presentation. Shared
 * so the topbar, the menu and the dashboard all flip at the same point.
 */
export const MOBILE_BREAKPOINT = 991

const query = `(max-width: ${MOBILE_BREAKPOINT}px)`

const matches = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false

/**
 * Tracks whether the viewport is phone-sized. Listens to the media query
 * itself rather than to `resize`, so it only reacts when the breakpoint is
 * actually crossed instead of on every pixel of a drag.
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(matches)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }

    const mediaQuery = window.matchMedia(query)
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)

    // Re-sync in case the viewport changed between first render and this effect.
    setIsMobile(mediaQuery.matches)
    mediaQuery.addEventListener('change', onChange)

    return () => mediaQuery.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
